<div class="min-h-screen relative bg-[#f5f5f5] overflow-hidden">
  <div class="absolute inset-0 hidden lg:grid grid-cols-2">
    <div class="bg-slate-200"></div>
    <div class="bg-primary"></div>
  </div>

  <div class="relative z-10 min-h-screen flex items-center justify-center px-4  pb-12 overflow-y-auto">
    <nz-card
      class="border-0 mx-auto w-full max-w-[520px] drop-shadow-lg sm:p-4 rounded-[10px]"
    >
      <form nz-form [formGroup]="registrationForm" nzLayout="vertical">
        <h3>Sign Up</h3>

        <div *ngIf="msg">
          <nz-alert
            *ngIf="actionMessage.display && actionMessage.isAdd"
            class="mt-2"
            [nzType]="actionMessage.type"
            [nzMessage]="actionMessage.message"
            nzShowIcon
            nzCloseable>
          </nz-alert>
        </div>

        <div class="grid grid-cols-2 gap-4 mt-6">
          <nz-form-item class="m-0">
            <nz-form-label class="flex w-full" nzRequired nzFor="firstname">
              First Name
            </nz-form-label>
            <nz-form-control [nzErrorTip]="firstNameCheck">
              <input
                type="text"
                nz-input
                formControlName="firstname"
                placeholder="Enter first name"
              />
            </nz-form-control>
            <ng-template #firstNameCheck>
              <span *ngIf="formErrors.firstname.required">First name is required</span>
            </ng-template>
          </nz-form-item>

          <nz-form-item class="m-0">
            <nz-form-label class="flex w-full" nzRequired nzFor="lastname">
              Last Name
            </nz-form-label>
            <nz-form-control [nzErrorTip]="lastNameCheck">
              <input
                type="text"
                nz-input
                formControlName="lastname"
                placeholder="Enter last name"
              />
            </nz-form-control>
            <ng-template #lastNameCheck>
              <span *ngIf="formErrors.lastname.required">Last name is required</span>
            </ng-template>
          </nz-form-item>
        </div>

        <nz-form-item class="mt-7">
          <nz-form-label class="flex w-full" nzRequired nzFor="email">
            Email
          </nz-form-label>
          <nz-form-control [nzErrorTip]="emailCheck">
            <input
              nz-input
              formControlName="email"
              placeholder="Enter email address"
            />
          </nz-form-control>
          <ng-template #emailCheck>
            <span *ngIf="formErrors.email.required">Email is required</span>
            <span *ngIf="formErrors.email.email">Email is invalid</span>
          </ng-template>
        </nz-form-item>

        <nz-form-item class="mt-4">
          <nz-form-label class="flex w-full"  nzRequired nzFor="mobile">
            Contact Number
          </nz-form-label>
          <nz-form-control [nzErrorTip]="contactNumberCheck">
            <nz-input-group [nzAddOnBefore]="selectBefore">
              <ng-template #selectBefore>
                <nz-select
                  nzAllowClear
                  nzShowSearch
                  nzPlaceHolder="+1"
                  formControlName="dialCode"
                  style="width: 100px"
                  [nzDropdownStyle]="{ width: '250px' }">
                  <nz-option
                    *ngFor="let data of orderByName(countries)"
                    [nzValue]="data.dialing_code"
                    nzCustomContent="true"
                    [nzLabel]="data.dialing_code + ' ' + data.name">
                    <div class="flex">
                      <img [src]="data.image" width="20" height="20" alt="country">
                      <span class="mx-2">{{ data.name }}</span>
                      <span>{{ data.dialing_code }}</span>
                    </div>
                  </nz-option>
                </nz-select>
              </ng-template>

              <input
                nz-input
                formControlName="mobile"
                placeholder="Enter contact number"
              />
            </nz-input-group>

            <ng-template #contactNumberCheck>
              <span *ngIf="formErrors.mobile.pattern">Contact number is invalid</span>
              <span *ngIf="formErrors.mobile.required">Contact number is required</span>
            </ng-template>
          </nz-form-control>
        </nz-form-item>

        <div class="grid grid-cols-2 gap-4 mt-4">
          <nz-form-item>
            <nz-form-label class="flex w-full" nzRequired nzFor="companyName">
              Company Name
            </nz-form-label>
            <nz-form-control [nzErrorTip]="companyNameCheck">
              <nz-input-group>
                <input
                  type="text"
                  nz-input
                  formControlName="companyName"
                  placeholder="Enter company name"
                />
              </nz-input-group>
            </nz-form-control>
            <ng-template #companyNameCheck>
              <span *ngIf="formErrors.companyName.required">
                Company name is required
              </span>
            </ng-template>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label class="flex w-full" nzRequired nzFor="shortCode">
              Company Code
            </nz-form-label>
            <nz-form-control [nzErrorTip]="shortCodeCheck">
              <input
                type="text"
                nz-input
                formControlName="shortCode"
                placeholder="ex: ABC"
              />
            </nz-form-control>
            <ng-template #shortCodeCheck>
              <span *ngIf="formErrors.shortCode.required">Company Code is required</span>
              <span *ngIf="formErrors.shortCode.maxlength">Company Code can be only 3 letters</span>
              <span *ngIf="formErrors.shortCode.pattern">Company Code can be only capital letters</span>
            </ng-template>
          </nz-form-item>
        </div>

        <nz-form-item>
          <nz-form-label class="flex w-full" nzRequired nzFor="password">
            Password
          </nz-form-label>
          <nz-form-control [nzErrorTip]="newPasswordCheck">
            <nz-input-group [nzSuffix]="newPasswordSuffixTemplate">
              <input
                [type]="passwordVisible ? 'text' : 'password'"
                nz-input
                placeholder="Enter password"
                formControlName="password"
              />
            </nz-input-group>
            <ng-template #newPasswordSuffixTemplate>
              <i
                class="cursor-on"
                nz-icon
                [nzType]="passwordVisible ? 'eye' : 'eye-invisible'"
                (click)="passwordVisible = !passwordVisible">
              </i>
            </ng-template>
          </nz-form-control>
          <ng-template #newPasswordCheck>
            <span *ngIf="formErrors.password.required">Password is required</span>
            <span *ngIf="formErrors.password.pattern">
              Password should more than 8 characters with at least one capital letter, one number, one simple letter
            </span>
          </ng-template>
        </nz-form-item>

        <div class="mt-6">
          <button
            nz-button
            nzType="primary"
            nzBlock
            (click)="onRegistration()"
            [disabled]="registrationForm.invalid">
            Sign Up
          </button>
        </div>

        <div class="grid grid-flow-row justify-center mt-6">
          <p class="text-sm">
            Already have an account?
            <a routerLink="/auth/login" class="text-sm font-semibold">Login</a>
          </p>
        </div>
      </form>
    </nz-card>
  </div>

  <div class="absolute bottom-3 left-1/2 -translate-x-1/2 z-20">
    <div class="px-4 py-1 bg-white rounded-full shadow-sm">
      <p class="text-center text-[#797C83] text-[11px] whitespace-nowrap">
        A Product by
        <b>
          <a
            target="_blank"
            href="https://purple.lk/"
            class="text-[#797C83]">
            Purple Software
          </a>
        </b>
      </p>
    </div>
  </div>
</div>
